import { estimateStringWidth, ELLIPSIS } from '@shopify/polaris-viz-core';

function endWordTruncate({
  word,
  targetWidth,
  characterWidths
}) {
  let nextCharacterIndex = 1;
  let newWord = '';

  if (estimateStringWidth(word, characterWidths) + characterWidths.W <= targetWidth) {
    return word;
  }

  while (newWord.length < word.length && estimateStringWidth(newWord, characterWidths) + characterWidths.W < targetWidth) {
    nextCharacterIndex += 1;
    newWord = word.substring(0, nextCharacterIndex);
    newWord = `${newWord}${ELLIPSIS}`;
  }

  return newWord;
}

export { endWordTruncate };
